import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api, money } from "@/lib/api";
import TxTable from "@/components/TxTable";

export default function AccountDetail() {
  const { id } = useParams();
  const [acc, setAcc] = useState(null);
  useEffect(() => { api.get(`/accounts/${id}`).then((r) => setAcc(r.data)); }, [id]);
  if (!acc) return <div className="text-slate-500">Loading...</div>;
  return (
    <div data-testid="account-detail">
      <Link to="/" className="inline-flex items-center gap-1 text-sm font-semibold text-[var(--blue)] mb-6" data-testid="back-to-accounts"><ArrowLeft size={15} /> All accounts</Link>
      <div className="tile mb-8 fade-up">
        <div className="p-8 flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-slate-500">{acc.type} ...{acc.number_last4}</p>
            <h1 className="text-3xl sm:text-4xl font-extrabold text-[var(--navy)] mt-1">{acc.name}</h1>
          </div>
          <div className="md:text-right">
            <div className="text-4xl font-display font-bold text-[var(--navy)]" data-testid="account-detail-balance">{money(acc.balance)}</div>
            <div className="text-xs text-slate-500">Available balance</div>
          </div>
        </div>
      </div>
      <h2 className="text-lg font-bold text-[var(--navy)] mb-4">Activity</h2>
      <TxTable accountId={id} />
    </div>
  );
}
